import { render, staticRenderFns } from "./lu-markdown.vue?vue&type=template&id=246b1f26&"
import script from "./lu-markdown.vue?vue&type=script&lang=js&"
export * from "./lu-markdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports